export default "__VITE_ASSET__5fc70bdf__"